(() => {
  const STATE_CLASSES = [
    'inventory-store-only',
    'inventory-sold-out',
    'inventory-online-only',
    'inventory-everywhere',
    'inventory-low-online',
    'inventory-error'
  ];

  const AVAILABLE_STATUSES = new Set(['in_stock', 'low_stock']);
  const ONLINE_WAREHOUSE_NAME = 'online warehouse';

  function getStatus(statusElement) {
    if (statusElement.classList.contains('invo-status-in_stock')) return 'in_stock';
    if (statusElement.classList.contains('invo-status-low_stock')) return 'low_stock';
    if (statusElement.classList.contains('invo-status-out_of_stock')) return 'out_of_stock';
    return 'unknown';
  }

  function readInventory(container) {
    const content = container?.matches?.('.invo-content')
      ? container
      : container?.querySelector?.('.invo-content') || document.querySelector('.invo-content');

    if (!content) return null;

    let onlineWarehouse = null;
    const stores = [];

    content.querySelectorAll('.invo-location').forEach((location) => {
      const nameElement = location.querySelector('.invo-location-name');
      const statusElement = location.querySelector('.invo-status');
      if (!nameElement || !statusElement) return;

      const entry = {
        element: statusElement,
        status: getStatus(statusElement)
      };

      if (nameElement.textContent.trim().toLowerCase() === ONLINE_WAREHOUSE_NAME) {
        onlineWarehouse = entry;
      } else {
        stores.push(entry);
      }
    });

    return { onlineWarehouse, stores };
  }

  function setDisplay(selector, value) {
    document.querySelectorAll(selector).forEach((element) => {
      if (value === '') element.style.removeProperty('display');
      else element.style.display = value;
    });
  }

  function setText(selector, value) {
    document.querySelectorAll(selector).forEach((element) => {
      element.textContent = value;
    });
  }

  function resetInterface() {
    document.body.classList.remove(...STATE_CLASSES);
    setDisplay('.t4s-product-form__buttons', '');
    setDisplay('.t4s-sticky-act-top', '');
    setDisplay('.instore-button', 'none');
    setDisplay('span.t4s-badge-item.t4s-badge-soldout', '');
    setDisplay('span.t4s-soldout-status.t4s-dn', '');
    setDisplay('.nostock-message', 'none');
  }

  function isPreorderVisible() {
    const status = document.querySelector('span[data-preorder-status]');
    return Boolean(status && !status.classList.contains('t4s-dn'));
  }

  function applyInventoryState(container) {
    resetInterface();

    const inventory = readInventory(container);
    if (!inventory?.onlineWarehouse) {
      document.body.classList.add('inventory-error');
      window.__inventoryCase = 'error';
      return;
    }

    const template = document.body.dataset.productTemplate || 'default';
    const online = inventory.onlineWarehouse.status;
    const storeStatuses = inventory.stores.map((store) => store.status);
    const anyStoreAvailable = storeStatuses.some((status) => AVAILABLE_STATUSES.has(status));
    const allStoresOut = storeStatuses.length > 0 &&
      storeStatuses.every((status) => status === 'out_of_stock');

    if (
      inventory.onlineWarehouse.element.textContent.replace(/\s+/g, ' ').trim() ===
      'Low in Stock - Call to Confirm'
    ) {
      inventory.onlineWarehouse.element.textContent = 'In Stock';
    }

    if (isPreorderVisible()) {
      if (template === 'nostocks-online') {
        setText('span[data-preorder-status], span[data-badge-preorder]', 'Available In-Store');
        setDisplay('.nostock-message', 'block');
      }

      window.__inventoryCase = 'preorder';
      return;
    }

    let inventoryCase = 'unknown';

    if (online === 'out_of_stock' && anyStoreAvailable) {
      inventoryCase = 'store_only';
      document.body.classList.add('inventory-store-only');
      setText('.t4s-soldout-status', 'Available In-Store');
      setDisplay('.t4s-sticky-act-top', 'none');

      if (template === 'nostocks-online') {
        setDisplay('.nostock-message', 'block');
        document.querySelectorAll('.t4s-btn-atc_text').forEach((buttonText) => {
          if (buttonText.textContent.trim().toLowerCase() === 'pre-order') {
            buttonText.textContent = 'Add to Cart';
          }
        });
      } else {
        setDisplay('.instore-button', 'block');
        setDisplay('.t4s-product-form__buttons', 'none');
        setDisplay('span.t4s-badge-item.t4s-badge-soldout', 'none');
      }
    } else if (online === 'out_of_stock' && allStoresOut) {
      inventoryCase = 'sold_out';
      document.body.classList.add('inventory-sold-out');
      setText('.t4s-soldout-status', 'Sold Out');
      setDisplay('.t4s-product-form__buttons, .t4s-sticky-act-top', 'none');
      setDisplay('span.t4s-badge-item.t4s-badge-soldout', 'none');
      setDisplay('span.t4s-soldout-status.t4s-dn', 'block');
      if (template === 'nostocks-online') setDisplay('.nostock-message', 'block');
    } else if (AVAILABLE_STATUSES.has(online) && allStoresOut) {
      inventoryCase = 'online_only';
      document.body.classList.add('inventory-online-only');
    } else if (online === 'in_stock' && anyStoreAvailable) {
      inventoryCase = 'everywhere';
      document.body.classList.add('inventory-everywhere');
    } else if (online === 'low_stock' && anyStoreAvailable) {
      inventoryCase = 'low_online_store_available';
      document.body.classList.add('inventory-low-online');
    } else {
      document.body.classList.add('inventory-error');
    }

    window.__inventoryCase = inventoryCase;
  }

  document.addEventListener('invo:changed', (event) => {
    applyInventoryState(event.detail?.container);
  });

  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.invo-container');
    if (container?.querySelector('.invo-content')) applyInventoryState(container);
  });
})();
